import React from "react";
import { BaseEdge, getBezierPath } from "@xyflow/react";

export default function WirelessEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
}) {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      style={{ stroke: "var(--color-signal-mic)", strokeDasharray: "2 2", strokeWidth: 2 }}
    />
  );
}
